import AppRoutes from "AppRoutes";
import { resolvePreferredName } from "helpers";
import { SendToTargetModel } from "models/SendToTargetModel";
import { useSendToPanel } from "providers";
import React from "react";

import { SendToFormMeeting } from "./SendToFormMeeting";
import { SendToFormSelection } from "./SendToFormSelection";

interface SendToFormRowProps {
  item: SendToTargetModel;
}

function shouldToggleSelected(event: React.MouseEvent, disabled: boolean) {
  const clickTarget = event.target as HTMLElement;
  if (!/td|tr/i.test(clickTarget.tagName)) return false;
  if (disabled) return false;
  return true;
}

export const SendToFormRow: React.FC<SendToFormRowProps> = ({ item }) => {
  const { getSelection, onSelectItem, onSetMeeting } = useSendToPanel();
  const { target, disabled, meetings = [] } = item;
  const { id: targetId } = target ?? {};
  const { selected, meetingId } = getSelection(targetId ?? 0);

  const key = `sendto-${targetId}`;
  const nameToUse = target ? resolvePreferredName(target) : "";
  const boardUrl = target ? AppRoutes.toBoardMeetings(target) : null;

  return (
    <>
      {!disabled && (
        <tr
          onClick={(e) => {
            if (!shouldToggleSelected(e, disabled ?? false)) return;
            onSelectItem(item);
          }}
          key={key}
        >
          <td className="selection">
            <SendToFormSelection
              disabled={meetings.length === 0}
              selected={selected}
              onChange={() => {
                onSelectItem(item);
              }}
            />
          </td>
          <td className="committee">{nameToUse}</td>
          <td>
            {boardUrl && (
              <a href={boardUrl} target="_blank" className="sbb-link">
                <i className="ms-Icon ms-Icon--NavigateExternalInline" />
              </a>
            )}
          </td>
          <td className="meeting">
            <SendToFormMeeting
              selected={selected}
              meetingId={meetingId ?? undefined}
              meetings={meetings}
              onChange={(newMeetingId) => {
                onSetMeeting(item, newMeetingId);
              }}
            />
          </td>
        </tr>
      )}
      {disabled && (
        <tr key={key}>
          <td className="selection" />
          <td className="committee">
            <span className="text-danger">{nameToUse}</span>
          </td>
          <td className="meeting">-</td>
        </tr>
      )}
    </>
  );
};
